/**
 * Tiebreaker Question Adapter
 *
 * Transforms admin preview data into TieBreakerQuestion component props
 */

import type { PreviewQuestionData } from '../types';

/**
 * TieBreakerQuestion component props (from packages/ui/src/components/TieBreakerQuestion.tsx)
 */
interface TieBreakerQuestionProps {
  questionId?: string;
  title?: string;
  description: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  points?: number;
  earnedPoints?: number;
  questionMetadata?: {
    dailyDouble?: boolean;
  };
}

/**
 * Transforms preview data into TieBreakerQuestion props
 *
 * Tiebreaker questions are simple numeric input fields.
 * In preview mode, the input is disabled and empty.
 *
 * @param data - Preview question data from admin form
 * @returns TieBreakerQuestion component props
 */
export function tiebreakerAdapter(data: PreviewQuestionData): TieBreakerQuestionProps {
  return {
    questionId: 'preview',
    title: 'Tiebreaker', // Standard title (matches user-facing tiebreaker.title i18n)
    description: data.questionText,
    value: '', // Empty in preview
    onChange: () => {}, // No-op handler (preview is view-only)
    disabled: true, // Preview is view-only
    points: data.totalPoints,
    earnedPoints: undefined,
  };
}
